import React from "react"
import SbEditable from "storyblok-react"
import Markdown from "react-markdown"
import { useStaticQuery, graphql } from "gatsby"
import { getFluidGatsbyImage } from "gatsby-storyblok-image"

import { Slide, SlideImage, transformLinkUri } from "gatsby-theme-gba"

const SlideEditable = ({ blok }) => {
  const fluidProps = getFluidGatsbyImage(blok.image, {
    maxWidth: 1360,
  })
  const { file, allFile } = useStaticQuery(graphql`
    query slideImageExampleQuery {
      file(relativePath: { eq: "slide-image.jpg" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      }
      allFile(filter: { id: { regex: "/(?:.*)slide/" } }) {
        edges {
          node {
            id
            name
            childImageSharp {
              fluid(maxWidth: 1360, quality: 80) {
                ...GatsbyImageSharpFluid_withWebp
              }
            }
          }
        }
      }
    }
  `)

  let filteredFiles = allFile.edges.filter(function(projectFile) {
    if (!projectFile.node.id.includes(blok.image.substring(1))) {
      return false // skip
    }

    return true
  })

  let imageFile = filteredFiles[0]
    ? filteredFiles[0].node.childImageSharp.fluid
    : fluidProps

  let link = blok.link.cached_url

  if (blok.link.linktype === "story") {
    link =
      blok.link.story && blok.link.story.full_slug
        ? blok.link.story.full_slug
        : link
  }

  return (
    <SbEditable content={blok}>
      <Slide
        heading={blok.heading}
        subHeading={blok.subHeading}
        subHeadingText={blok.subHeadingText}
        buttonLink={`/${link}`}
        buttonText={blok.linkText}
        buttonColor={blok.buttonColor}
        linkTarget={blok.linkTarget}
        body={
          <Markdown
            source={blok.body}
            transformLinkUri={uri => {
              return transformLinkUri(
                uri,
                "",
                blok.currentLanguage,
                blok.seoLinks
              )
            }}
          />
        }
        currentLanguage={blok.currentLanguage}
        seoLinks={blok.seoLinks}
      >
        <SlideImage
          fluid={imageFile || file.childImageSharp.fluid}
          alt={blok.imageAlt}
        />
      </Slide>
    </SbEditable>
  )
}

export default SlideEditable
